export const BOT_RESPONSES = [
  "🤖 My brain’s on vacation right now. Try again soon!",
  "Server’s out grabbing a coffee ☕. I’ll be back when it’s done thinking.",
  "Currently consulting the AI elders... please stand by.",
  "Oops! My data neurons tangled themselves again. Working on it!",
  "I tried to ask the server for help, but it ghosted me 👻."
];
